/**
 * 支持可以展开的Explanation
 * 当回答正确的时候默认收起，点击可用展开
 * 当回答错误的时候默认展开，点击可用收起
 */
import { colors } from "@/constant/colors";
import { ChevronDown, MessageSquareText } from "lucide-react";
import { useState } from "react";
import MarkdownComponent from "../Markdown";

interface ExpendExplanationProps {
  explanation: string;
  initialHideExplanation?: boolean;
  className?: string;
}

const ExpandExplanation = ({ explanation, initialHideExplanation: initialHideExplanation = false, className }: ExpendExplanationProps) => {
  const [showExplanation, setShowExplanation] = useState(!initialHideExplanation || false);

  const toggleExplanation = () => {
    setShowExplanation(!showExplanation);
  }

  return (
    <div className={`w-full max-w-[800px] px-4 sm:px-6 md:px-8 flex flex-col justify-start ${className}`}>
      <button 
        className="display-text flex items-center gap-2 mt-6 mb-2"
        style={{ color: colors.mainTextColor }}
        onClick={toggleExplanation}
      >
        <MessageSquareText />
        Explanation:
        <span className={`transform transition-transform duration-200 ${showExplanation ? 'rotate-180' : 'rotate-0'}`}>
          <ChevronDown />
        </span>
      </button>
      {showExplanation && (
        <div className={`flex flex-col mt-2 bg-[#FFEDC8] px-6 py-4 rounded-2xl transition-all duration-300`}>
          <div className="display-text">
            <MarkdownComponent content={explanation} textStyle={{ fontSize: '16px', textAlign: 'left', fontFamily: 'var(--font-display)', color: colors.mainTextColor, fontWeight: '400' }} />
          </div>
        </div>
      )}
    </div>
  )
}

export default ExpandExplanation;